module.exports = __webpack_public_path__ + "static/product-l0970-coyote-tan-9f1575ab3266cadb1227263cf6855185.png";